import { gql } from "graphql-tag";

export const PROMOTION_FIELDS = gql`
    fragment PromotionFields on Promotion {
        id
        type
        title
        message
        url
        image_path
        image {
            id
            file_path
        }
        audience_type
        status
        starts_at
        ends_at
        customer_ids
        customer_group_ids
        recipient_preview
        recipient_count
    }
`;

export default { PROMOTION_FIELDS };
